'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerEventHandlers = exports.isEventName = exports.eventNames = exports.props = exports.EVENT_ME_GET = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _Event = require('./Event');

var _EventHandler = require('./EventHandler');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @readonly
 * @type {string}
 */
/**
 * Defines events and event related functionality which are closely related to an application's context
 *
 * @module Core/ContextUserEvents
 */

var EVENT_ME_GET = exports.EVENT_ME_GET = 'context.me_get';

var events = {

  EVENT_ME_GET: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_REQUESTRESPONSE }
};

/**
 * @enum
 * @readonly
 * @type {{EVENT_ME_GET: {channelType: string, invocationType: string}, EVENT_TAB_DATA: {channelType: string, invocationType: string}, EVENT_TAB_ACTIVATE: {channelType: string, invocationType: string}, EVENT_TAB_CLOSE: {channelType: string, invocationType: string}}}
 */
var props = exports.props = events;

/**
 * @readonly
 * @type {Array<string>}
 */
var eventNames = exports.eventNames = (0, _keys2.default)(events).map(function (key) {
  return events[key];
});

/**
 * @method
 *
 * @param {string} name
 * @return {boolean}
 */
var isEventName = exports.isEventName = function isEventName(name) {
  return eventNames.indexOf(name) !== -1;
};

/**
 * @method
 * @param {WidgetWindowBridge} windowBridge
 * @param {AppClient} app
 */
var registerEventHandlers = exports.registerEventHandlers = function registerEventHandlers(windowBridge, app) {
  (0, _EventHandler.handleOutgoingEvent)(windowBridge, app, EVENT_ME_GET, events.EVENT_ME_GET);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Core/ContextUserEvents.js
// module id = 103
// module chunks = 0